import { useQuery } from './query';

export function useTravelerInterest({
  dispatch,
  getTravelerInterest,
  integrationSettings,
  prePopulation,
  meta,
  pageContext,
  selectedItems
}) {
  const getData = () => {
    return getTravelerInterest(prePopulation, integrationSettings, meta, pageContext)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  };

  const travelersInterest = useQuery({ getData }, [
    integrationSettings,
    prePopulation.travelerInterest,
    meta,
    getTravelerInterest
  ]);

  const onChange = (payload) => {
    dispatch({
      type: 'TRAVELER_CHANGE',
      payload
    });
    dispatch({ type: 'CHANGE_TRAVEL_INTEREST_CONFIRMATION', payload: true });
    dispatch({ type: 'SET_LAST_USER_ACTION_CHANGED', payload: 'TRAVELER_CHANGE' });
    dispatch({ type: 'TRAVEL_INTEREST_CHANGE_PROCESSED', payload: Date.now() });
  };

  const onClear = (payload) => {
    dispatch({
      type: 'TRAVELER_CLEAR',
      payload
    });
    dispatch({ type: 'CHANGE_TRAVEL_INTEREST_CONFIRMATION', payload: true });
    dispatch({ type: 'SET_LAST_USER_ACTION_CHANGED', payload: 'TRAVELER_CHANGE' });
    dispatch({ type: 'TRAVEL_INTEREST_CHANGE_PROCESSED', payload: Date.now() });
  };

  return {
    travelersInterest,
    selectedItems,
    onChange,
    onClear
  };
}

export function isPrepopulate(prePopulation) {
  const categories = prePopulation?.travelerInterest?.categories;
  if (categories) {
    for (let index = 0; index < categories.length; index++) {
      const category = categories[index];
      if (category?.prepopulateInterest?.length > 0) {
        return true;
      }
    }
  }
  return false;
}

export function getPrepopulateInterest(prePopulation) {
  if (isPrepopulate(prePopulation)) {
    const categories = prePopulation?.travelerInterest?.categories;
    let result = {};
    for (let index = 0; index < categories.length; index++) {
      const category = categories[index];
      const prepopulateInterest = category?.prepopulateInterest;
      if (prepopulateInterest && prepopulateInterest?.length > 0) {
        result[category?.id] = {
          selectedItems: prepopulateInterest.map((interest) => {
            return { value: interest };
          })
        };
      }
    }
    return result;
  } else {
    return {};
  }
}
